import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const GameBackground = () => {
  const [items, setItems] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const newItems = Array.from({ length: 15 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100 + '%',
      size: Math.random() * 50 + 20 + 'px',
      delay: Math.random() * 20 + 's',
      duration: Math.random() * 15 + 15 + 's',
      type: Math.random() > 0.5 ? 'bubble' : 'star'
    }));
    setItems(newItems);
  }, []);

  const getGradient = () => {
    if (location.pathname.includes('play')) {
      return 'from-pink-100 via-purple-100 to-blue-100';
    }
    return 'from-pink-50 via-purple-50 to-blue-50';
  };

  return (
    <div className={`fixed inset-0 -z-10 overflow-hidden bg-gradient-to-br ${getGradient()} transition-colors duration-1000`}>
      {/* Floating Elements */}
      {items.map(item => (
        <div
          key={item.id}
          className="bg-floating-item rounded-full absolute bg-white/30 blur-sm"
          style={{
            left: item.left,
            width: item.size,
            height: item.size,
            animationDelay: item.delay,
            animationDuration: item.duration,
            borderRadius: item.type === 'star' ? '10%' : '50%'
          }}
        />
      ))}
    </div>
  );
};

export default GameBackground;